import VideoPlaybackService from '@/services/VideoPlaybackService'

export default {
  methods: {
    playbackVideo(videoUrl) {
      if (videoUrl) {
        new VideoPlaybackService().showVideo(videoUrl)
      } else {
        this.$f7.dialog.alert('再生できませんでした', '動画再生')
      }
    },
  },
}
